import React from "react";

const SvgA = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="A_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#A_svg__a)">
      <path
        d="M11.01 185v9.21H8.37V185H4.92l1.58-2.64h1.82v-12.95a8.221 8.221 0 0 1 1.15-4.22 8.58 8.58 0 0 1 3.12-3.12 8.31 8.31 0 0 1 8.44 0 8.58 8.58 0 0 1 3.12 3.12 8.221 8.221 0 0 1 1.15 4.22v24.79h-2.59v-9.21l-11.7.01zm0-2.64h11.7v-12.95a5.67 5.67 0 0 0-.84-3.07 5.759 5.759 0 0 0-2.18-2.06 5.913 5.913 0 0 0-2.83-.72 5.47 5.47 0 0 0-4.22 1.77 5.852 5.852 0 0 0-1.63 4.08v12.95z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgA;
